import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

// components
import AuthModernLayout from 'src/layouts/auth/modern';
import DiwaliTheme from 'src/sections/auth/festival/themes/DiwaliTheme';
import LohriTheme from 'src/sections/auth/festival/themes/LohriTheme';
import HoliTheme from 'src/sections/auth/festival/themes/HoliTheme';
import NavratriTheme from 'src/sections/auth/festival/themes/NavratriTheme';
import ChristmasTheme from 'src/sections/auth/festival/themes/ChristmasTheme';
import EidTheme from 'src/sections/auth/festival/themes/EidTheme';
import IndependenceTheme from 'src/sections/auth/festival/themes/IndependenceTheme';
import RepublicTheme from 'src/sections/auth/festival/themes/RepublicTheme';
import RamnavmiTheme from 'src/sections/auth/festival/themes/RamnavmiTheme';
import RakshaBandhanTheme from 'src/sections/auth/festival/themes/RakshaBandhanTheme';
import GaneshChaturthiTheme from 'src/sections/auth/festival/themes/GaneshChaturthiTheme';
import UttarayanTheme from 'src/sections/auth/festival/themes/UttarayanTheme';
import OnamTheme from 'src/sections/auth/festival/themes/OnamTheme';

import { SplashScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));
const ChangePasswordPage = lazy(() => import('src/pages/auth/ChangePasswordPage'));

// Festival
const DiwaliLoginPage = lazy(() => import('src/pages/auth/festival/diwali-login'));
const HoliLoginPage = lazy(() => import('src/pages/auth/festival/holi-login'));
const NavratriLoginPage = lazy(() => import('src/pages/auth/festival/navratri-login'));
const LohriLoginPage = lazy(() => import('src/pages/auth/festival/lohri-login'));
const ChristmasLoginPage = lazy(() => import('src/pages/auth/festival/christmas-login'));
const EidLoginPage = lazy(() => import('src/pages/auth/festival/eid-login'));
const IndependenceLoginPage = lazy(() => import('src/pages/auth/festival/independence-login'));
const RepublicLoginPage = lazy(() => import('src/pages/auth/festival/republic-login'));
const RamnavmiLoginPage = lazy(() => import('src/pages/auth/festival/ramnavmi-login'));
const RakshaBandhanLoginPage = lazy(() => import('src/pages/auth/festival/rakshabandhan-login'));
const GaneshChaturthiLoginPage = lazy(() => import('src/pages/auth/festival/ganesh-chaturthi-login'));
const UttarayanLoginPage = lazy(() => import('src/pages/auth/festival/uttarayan-login'));
const OnamLoginPage = lazy(() => import('src/pages/auth/festival/onam-login'));

// ----------------------------------------------------------------------

const authJwt = {
  path: 'jwt',
  element: (
    <Suspense fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  ),
  children: [
    {
      path: 'login',
      element: <JwtLoginPage />,
    },
    {
      path: 'change-password',
      element: (
        <AuthModernLayout>
          <ChangePasswordPage />
        </AuthModernLayout>
      ),
    },
    {
      path: 'festival',
      children: [
        {
          path: 'diwali',
          element: (
            <DiwaliTheme>
              <DiwaliLoginPage />
            </DiwaliTheme>
          ),
        },
        {
          path: 'lohri',
          element: (
            <LohriTheme>
              <LohriLoginPage />
            </LohriTheme>
          ),
        },
        {
          path: 'holi',
          element: (
            <HoliTheme>
              <HoliLoginPage />
            </HoliTheme>
          ),
        },
        {
          path: 'navratri',
          element: (
            <NavratriTheme>
              <NavratriLoginPage />
            </NavratriTheme>
          ),
        },
        {
          path: 'christmas',
          element: (
            <ChristmasTheme>
              <ChristmasLoginPage />
            </ChristmasTheme>
          ),
        },
        {
          path: 'eid',
          element: (
            <EidTheme>
              <EidLoginPage />
            </EidTheme>
          ),
        },
        {
          path: 'independence',
          element: (
            <IndependenceTheme>
              <IndependenceLoginPage />
            </IndependenceTheme>
          ),
        },
        {
          path: 'republic',
          element: (
            <RepublicTheme>
              <RepublicLoginPage />
            </RepublicTheme>
          ),
        },
        {
          path: 'ramnavmi',
          element: (
            <RamnavmiTheme>
              <RamnavmiLoginPage />
            </RamnavmiTheme>
          ),
        },
        {
          path: 'rakshabandhan',
          element: (
            <RakshaBandhanTheme>
              <RakshaBandhanLoginPage />
            </RakshaBandhanTheme>
          ),
        },
        {
          path: 'ganesh-chaturthi',
          element: (
            <GaneshChaturthiTheme>
              <GaneshChaturthiLoginPage />
            </GaneshChaturthiTheme>
          ),
        },
        {
          path: 'uttarayan',
          element: (
            <UttarayanTheme>
              <UttarayanLoginPage />
            </UttarayanTheme>
          ),
        },
        {
          path: 'onam',
          element: (
            <OnamTheme>
              <OnamLoginPage />
            </OnamTheme>
          ),
        },
      ],
    },
  ],
};

export const authRoutes = [
  {
    path: 'auth',
    children: [authJwt],
  },
];
